(() => {
  const CART_DRAWER_SELECTOR = 'theme-drawer#cart-drawer';
  const CART_ACTION_SELECTOR = [
    '._rsi-buy-now-button-cart',
    '#_rsi-buy-now-button._rsi-buy-now-button-cart',
    '#_rsi-buy-now-button-overwrite._rsi-buy-now-button-cart',
    '[data-rsi-button]',
    '[data-releasit-button]',
  ].join(',');

  const replayingClicks = new WeakSet();
  const pendingClicks = new WeakSet();

  /**
   * Releasit opens its form outside Horizon's cart drawer. On mobile the
   * drawer is a native modal dialog, so the form is rendered behind the
   * browser top layer until the drawer is closed. Close the drawer first,
   * then replay the original action once the close animation has finished.
   *
   * @param {MouseEvent} event
   */
  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) return;

      const action = event.target.closest(CART_ACTION_SELECTOR);
      if (!(action instanceof HTMLElement)) return;

      const drawer = action.closest(CART_DRAWER_SELECTOR);
      if (!(drawer instanceof HTMLElement) || !drawer.hasAttribute('open')) return;

      if (replayingClicks.has(action)) {
        replayingClicks.delete(action);
        return;
      }

      if (pendingClicks.has(action)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const panel = drawer.querySelector(':scope > dialog[open]');
      if (!(panel instanceof HTMLDialogElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      pendingClicks.add(action);
      action.setAttribute('aria-busy', 'true');

      try {
        if (typeof drawer.close === 'function') {
          await drawer.close();
        } else {
          panel.close();
          drawer.removeAttribute('open');
        }

        if (!document.contains(action)) return;

        replayingClicks.add(action);
        action.click();
      } finally {
        pendingClicks.delete(action);
        action.removeAttribute('aria-busy');
      }
    },
    true
  );
})();
